export default "__VITE_ASSET__DCXFKDIV__"